import { NavbarBrand, NavbarItem } from '@heroui/navbar';
import { Avatar } from '@heroui/avatar';
import { Link } from '@heroui/link';
import Brand from '@/components/Layouts/Default/Brand';
import { NextUI } from '@/components/NextUI';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AccountDropdown from '@/components/Common/AccountDropdown';
import React, { useState } from 'react';
import { User } from '@/types/models/user';
import { useTranslations } from 'next-intl';
import { APP_EVENTS, logHubxEvent } from '@/app/providers/analytics';

const NavbarMobileTop = ({
  user,
  isMenuOpen,
  setIsMenuOpen,
  isToolsOpen,
  setIsToolsOpen,
}: {
  user: User | null;
  isMenuOpen: boolean;
  setIsMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isToolsOpen: boolean;
  setIsToolsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const t = useTranslations('navbar');

  return (
    <div className="w-full flex justify-between gap-2 md:gap-4 items-center">
      <div className="flex justify-center items-center gap-5">
        <NavbarBrand
          className="hover:opacity-100 !flex-initial"
          as={Link}
          href={'/'}
        >
          <Brand />
        </NavbarBrand>
        <NavbarItem>
          <NextUI.Button
            data-hover={isOpen}
            disableAnimation
            variant="link"
            className="font-normal !flex !items-center hover:!text-primary-dark-blue"
            onClick={() => {
              setIsMenuOpen(false);
              setIsToolsOpen(!isToolsOpen);
              logHubxEvent({
                eventName: APP_EVENTS.BTN_HEADER,
                source: 'all_tools',
              });
            }}
          >
            <FontAwesomeIcon icon={['fas', 'grip']} />
            {t('tools')}
            <FontAwesomeIcon
              icon={
                isToolsOpen ? ['fas', 'chevron-up'] : ['fas', 'chevron-down']
              }
              size="2xs"
              className="text-gray-medium text-[12px] md:text-[14px] transition-transform duration-200 ease-in-out transform"
            />
          </NextUI.Button>
        </NavbarItem>
      </div>
      <div className="flex items-center justify-center gap-2">
        <NavbarItem>
          <NextUI.Button
            isIconOnly
            className="!bg-transparent !w-[42px] !md:w-12 !h-[42px] !md:h-12 !p-0 hover:bg-transparent text-gray-dark !hover:bg-transparent"
            onClick={() => {
              setIsMenuOpen(!isMenuOpen);
              setIsToolsOpen(false);
            }}
          >
            {user ? (
              <>
                <span className="hidden md:block">
                  <AccountDropdown />
                </span>
                <span className="md:hidden ">
                  <Avatar
                    color={'primary'}
                    classNames={{
                      name: 'text-lg uppercase',
                    }}
                    getInitials={(name) =>
                      name
                        .split(' ')
                        .map((n) => n[0])
                        .join('')
                        .slice(0, 2)
                    }
                    name={user?.name}
                    className="w-[42px] !rounded-full h-[42px] cursor pointer"
                  />
                </span>
              </>
            ) : (
              <FontAwesomeIcon
                icon="bars"
                className="text-gray-medium text-[20px] "
              />
            )}
          </NextUI.Button>
        </NavbarItem>
      </div>
    </div>
  );
};

export default NavbarMobileTop;
